var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.is_visible,"width":"560px"},on:{"close":_vm.closeDialog}},[(!_vm.tableData.length)?_c('Alert',{attrs:{"text":_vm.emptyMessage,"type":'info'}}):_c('DialogTable',{attrs:{"tableColumns":_vm.tableColumns,"tableData":_vm.tableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }